import {
  NotificationActionType,
  Platform,
} from "@shared/features/settings/types";
import { EnvType } from "@shared/types/common";

export enum NotificationScreens {
  DASHBOARD = "dashboard",
  TRADES = "trades",
  TRADE_DETAIL = "trade_detail",
  GROUPS = "groups",
  ACCOUNT_DETAIL = "account_detail",
  BOT_DETAIL = "bot_detail",
  ACCOUNT_FORM = "account_form",
  UPGRADE_PACKAGE = "upgrade_package",
  SUBSCRIPTION = "subscription",
}

export enum NotificationStatus {
  READ = "read",
  UNREAD = "unread",
}

export interface Notification {
  title: string;
  message: string;
  status: NotificationStatus;
  time: number;
  screen: NotificationScreens;
  screen_header: string | null;
  tab_number: number | null;
  component_id: number;
  component_type: NotificationComponent;
  main_icon_link: string;
  type_icon_link: string | null;
  type: string;
  button_icon_link?: string;
  button_text?: string;
  button_link?: string;
  notification_id: number;
  main_component_id: number;
  color?: NotificationColor;
  sub_message?: string;
  env_type?: EnvType;
}

export enum NotificationComponent {
  TRADE = "trade",
  ORDER = "order",
  SIGNAL = "signal",
  TARGET = "target",
  SUB_GROUP = "sub_group",
  USER = "user",
  DCA_BOT = "dca_bot",
  CLIENT = "client",
}

export enum NotificationColor {
  BLUE = 1,
  GREEN = 2,
  RED = 3,
  YELLOW = 4,
}

export type NotificationActionTypeData = {
  name: string;
  type: NotificationActionType;
  is_web_active: boolean;
  is_telegram_active: boolean;
};

export type NotificationsSectionData = {
  name: string;
  data: NotificationActionTypeData[];
};

export type GetNotificationsDataResponse = {
  telegram_notifications_active: boolean;
  web_notifications_active: boolean;
  data: NotificationsSectionData[];
};

export type BulkChangeNotificationActionRequest = {
  notification_action_types: NotificationActionType[];
  telegram_coupling_type: Platform;
  is_active: boolean;
};

export type ChangePlatformIsActiveRequest = {
  telegram_coupling_type: Platform;
  is_active: boolean;
};
